/* eslint-disable max-len */
import React from 'react';
import { IconType } from '@react-icons/all-files';

export const ItvEdit: IconType = ({ width = '1em', height = '1em', ...props }) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 240 240"
    fill="currentColor"
    width={width}
    height={height}
    {...props}
  >
    <path d="M219.8,82.2c0,0,0-.2,0-.3,0-.2,0-.5.1-.7,0,0,0-.1,0-.2,0-.2,0-.4,0-.7s0-.2,0-.3c0-.2,0-.3,0-.5s0-.3,0-.5c0-.1,0-.2,0-.3,0-.2,0-.4,0-.6,0,0,0-.1,0-.2,0-.2-.1-.5-.2-.8,0,0,0,0,0,0-.2-.6-.4-1.2-.7-1.7-.1-.2-.3-.5-.4-.7,0,0,0,0,0-.1-.4-.6-.8-1.1-1.3-1.6h0l-50-50c-3.9-3.9-10.2-3.9-14.1,0l-9.9,9.9s0,0,0,0L22.9,152.9c-1.9,1.9-2.9,4.4-2.9,7.1v50c0,5.5,4.5,10,10,10h50c2.7,0,5.2-1.1,7.1-2.9L217.1,87.1c.1,0,.2-.2.3-.3s.2-.2.3-.3c.2-.3.5-.6.7-.9h0c.6-.8,1-1.8,1.3-2.7,0-.2.1-.4.2-.6h0ZM90,185.9l-35.5-35.5,102.3-93.8,37.5,25-104.3,104.3h0ZM40,200v-35.9l35.9,35.9h-35.9Z" />
  </svg>
);
